import get from 'get-value';
import isObject from 'isobject';
import { propertyExists } from './api-utils';

export const realUnset = ( obj, prop ) => {
	if ( !isObject( obj ) ) {
		throw new TypeError( 'expected an object.' );
	}
	if ( propertyExists( obj, prop ) ) {
		delete obj[prop];
		return true;
	}

	// `unset-value` does not unset falsey values, so we've changed `has` to `get`.
	if ( get( obj, prop ) !== undefined ) {
		var segs = prop.split( '.' );
		var last = segs.pop();
		while ( segs.length && segs[segs.length - 1].slice( -1 ) === '\\' ) {
			last = segs.pop().slice( 0, -1 ) + '.' + last;
		}
		while ( segs.length ) obj = obj[prop = segs.shift()];
		return ( delete obj[last] );
	}
	return true;
};
